import { useMemo } from 'react'

import DatePicker from 'material/DatePicker'

import { useFocusedApplicationCycle } from '../AppRoundProvider'
import { useAppCycleEndDate, useAppCycleStartDate } from './app-round-helper'

type DeadlinePickerProps = {
  onUpdate: (update: string) => void
  onError: (error?: React.ReactElement) => void
  deadline?: string
  cutoff?: string
}

const DeadlineDatePicker = ({ onUpdate, deadline, cutoff, onError }: DeadlinePickerProps) => {
  const applicationCycle = useFocusedApplicationCycle()
  const minDate = useAppCycleStartDate(applicationCycle)
  const appCycleMaxDate = useAppCycleEndDate(applicationCycle)
  const maxDate = useMemo(() => (cutoff ? new Date(cutoff) : appCycleMaxDate), [appCycleMaxDate, cutoff])
  return (
    <DatePicker
      required
      fullWidth
      date={deadline}
      FormHelperTextProps={{ role: 'alert' }}
      onError={onError}
      onChange={onUpdate}
      autoOk
      label="Deadline Date"
      format="MM/dd/yyyy"
      minDateMessage="The deadline date cannot precede today nor the start of academic year cycle July 31"
      maxDateMessage="Date cannot be after July 31 of the academic year nor the current cutoff"
      invalidDateMessage="Must be formatted to MM/DD/YYYY"
      disablePast
      minDate={minDate}
      maxDate={maxDate}
      id="deadline-date"
    />
  )
}

export default DeadlineDatePicker
